import { getProgressTextColors } from "../textColors";
import React from "react";
import { useTheme } from "../../../contexts/ThemeContext";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import "./index.css";

export const KpiCard = ({
  label,
  value,
  icon,
  accentColor = "rgba(236, 178, 54, 0.65)",
  active = false,
  onClick,
}) => {
  const theme = useTheme();
  const textColors = getProgressTextColors(theme.mode);
  const isDark = theme.mode === "dark";
  const contentColor = active ? "#ffffff" : textColors.primary;
  const ACTIVE_COLOR = "#ecb236";
  const ACTIVE_ICON_COLOR = "#f5be47";
  const INACTIVE_ICON_COLOR = "rgba(236, 178, 54, 0.65)";

  return (
    <button
      type="button"
      onClick={onClick}
      className={`group flex flex-col tablet:flex-row items-center tablet:justify-between p-2.5 tablet:p-6 rounded-xl tablet:rounded-2xl flex-1 tablet:min-w-[240px] text-center tablet:text-left transition-all duration-200 cursor-pointer ${
        active ? "is-active" : ""
      }`}
      style={{
        backgroundColor: isDark
          ? active
            ? "rgba(236, 178, 54, 0.05)"
            : "rgba(255, 255, 255, 0.02)"
          : active
          ? "#11121f"
          : "#FFFFFF",
        border: active
          ? `1.5px solid ${ACTIVE_COLOR}`
          : isDark
          ? "1px solid rgba(255, 255, 255, 0.08)"
          : "1px solid rgba(0, 0, 0, 0.08)",
        boxShadow: active
          ? "0 0 16px -2px rgba(236, 178, 54, 0.25), 0 4px 12px rgba(0, 0, 0, 0.1)"
          : isDark
          ? "0 4px 12px rgba(0, 0, 0, 0.2)"
          : "0 2px 8px rgba(0, 0, 0, 0.04)",
      }}
      onMouseEnter={(e) => {
        if (!active) {
          e.currentTarget.style.borderColor = isDark
            ? "rgba(255, 255, 255, 0.22)"
            : "rgba(0, 0, 0, 0.18)";
          e.currentTarget.style.transform = "translateY(-1px)";
        }
      }}
      onMouseLeave={(e) => {
        if (!active) {
          e.currentTarget.style.borderColor = isDark
            ? "rgba(255, 255, 255, 0.08)"
            : "rgba(0, 0, 0, 0.08)";
          e.currentTarget.style.transform = "translateY(0)";
        }
      }}
    >
      <div className="flex flex-col tablet:flex-row items-center gap-1.5 tablet:gap-5 w-full tablet:w-auto justify-center tablet:justify-start">
        {icon && (
          <div
            className="flex items-center justify-center transition-all duration-200 group-hover:scale-110 shrink-0"
            style={{
              color: active ? ACTIVE_ICON_COLOR : (accentColor || INACTIVE_ICON_COLOR),
              filter: active ? "drop-shadow(0 0 8px rgba(236, 178, 54, 0.45))" : "none",
            }}
          >
            {React.isValidElement(icon)
              ? React.cloneElement(icon, { sx: { fontSize: { xs: 24, tablet: 40 } } })
              : icon}
          </div>
        )}
        <div className="flex flex-col items-center tablet:items-start min-w-0">
          <p
            className="text-xl tablet:text-4xl lg:text-5xl font-extrabold leading-none tracking-tight font-montserrat m-0"
            style={{
              color: contentColor,
            }}
          >
            {value}
          </p>
          <p
            className="text-[11px] tablet:text-[max(1rem,16px)] font-medium mt-1 tablet:mt-2 transition-colors leading-tight text-center tablet:text-left m-0"
            style={{
              color: contentColor,
              opacity: active ? 1 : 0.8,
            }}
          >
            {label}
          </p>
        </div>
      </div>

      <div
        aria-hidden="true"
        className={`kpi-chevron-wrapper kpi-card-chevron-motion items-center justify-center shrink-0 ml-2${active ? " kpi-card-chevron-motion--active" : ""}`}
        style={{
          color: active
            ? ACTIVE_COLOR
            : isDark
            ? "rgba(255, 255, 255, 0.25)"
            : "rgba(0, 0, 0, 0.25)",
        }}
      >
        <ChevronRightIcon className="kpi-card-chevron" sx={{ fontSize: 26 }} />
      </div>
    </button>
  );
};
